/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-14 09:50:35
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */
import { toVisualThousands } from "../utils";
import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

export default  ({ label, list = [], color = [] }) => {
  console.log(list)
  const _data = [...list];
  const _color = [...color];
  _data.reverse();
  _color.reverse();

  return {
    title: {
      text: '索尼品牌美誉度月度变化情况',
      textAlign: 'center',
      top: 20,
      textStyle: {
        color: '#fff',
        fontSize: '22',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color: _color,
    legend: {
      bottom: 0,
      icon: 'stake',
      itemWidth: 13,
      textStyle: {
        color: '#fff',
        fontSize: 16
      },
      data: list.map((item)=>{
        return item.name;
      })
    },
    grid: {
      left: '5%',
      right: '2%',
      bottom: '13%',
      top: '13%',
      containLabel: false
    },
    xAxis: {
      show: true,
      type: 'category',
      boundaryGap: false,
      data: label,
      axisLabel: { ...xAxisLabelColor, color: '#fff', fontSize: '18px' },
      axisLine: { 
        show: true,
        lineStyle: {
          color: '#fff'
        }
       },
      axisTick: { show: true },
      minorTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      axisLabel: { ...yAxisLabelColor, color: '#fff', fontSize: '14px' },
      splitLine: { show: false },
    },
    series: _data.map(item => ({
      stack: 'same',
      type: 'line',
      symbol: false,
      areaStyle: { opacity: 1 },
      name: item.name,
      data: item.list,
      label: {
        formatter: (ele) => toVisualThousands(ele.value),
      }
    })),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P38/chart.js